import React from 'react';
import SafeIcon from '../common/SafeIcon.jsx';
import * as FiIcons from 'react-icons/fi';

const { FiHome, FiX } = FiIcons;

const Header = ({ onBackToHome, showLogo = true, showHomeButton = false, showCancelButton = false, onCancel }) => {
  return (
    <header className="py-4 px-6 bg-[#f3ede6] border-b border-gray-200">
      <div className="container mx-auto">
        <div className="flex items-center justify-between">
          {/* Logo Section */}
          <div className="flex items-center">
            {showLogo && (
              <button 
                onClick={onBackToHome} 
                className="cursor-pointer hover:opacity-80 transition-opacity"
                aria-label="Return to home"
              >
                <img 
                  src="https://filedn.com/lujmEiF7ALfJ9rDUrehIfEz/FetchMate.png" 
                  alt="FetchMate Logo" 
                  className="h-[60px] object-contain"
                  onError={(e) => {
                    console.error('Failed to load logo image');
                    // Final fallback to text
                    e.target.style.display = 'none';
                    const fallback = document.createElement('div');
                    fallback.className = 'text-2xl font-bold text-[#F2674C] cursor-pointer hover:opacity-80';
                    fallback.textContent = 'FetchMate';
                    fallback.onclick = onBackToHome;
                    e.target.parentNode.appendChild(fallback);
                  }}
                />
              </button>
            )}
          </div>

          {/* Navigation Buttons */}
          <div className="flex items-center space-x-4">
            {showHomeButton && (
              <button 
                onClick={onBackToHome}
                className="flex items-center px-4 py-2 text-[#282f3a] hover:text-[#F2674C] hover:bg-white/50 rounded-xl transition-all duration-300 font-semibold"
                aria-label="Return to home"
              >
                <SafeIcon icon={FiHome} className="w-4 h-4 mr-2" />
                Home
              </button>
            )}
            {showCancelButton && (
              <button 
                onClick={onCancel}
                className="flex items-center px-4 py-2 text-gray-600 hover:text-red-600 hover:bg-white/50 rounded-xl transition-all duration-300 font-semibold"
                aria-label="Cancel assessment"
              >
                <SafeIcon icon={FiX} className="w-4 h-4 mr-2" />
                Cancel
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;